import React, { useEffect, useRef, useState } from "react";
import { appLinks } from "../config/apps";

const AppSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const switcherRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (switcherRef.current && !switcherRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="relative" ref={switcherRef}>
      <button
        type="button"
        onClick={() => setIsOpen((previous) => !previous)}
        className="inline-flex h-10 w-10 items-center justify-center rounded-full text-slate-400 transition-colors hover:bg-slate-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/60"
        aria-label="Open ConvoLink apps"
        aria-expanded={isOpen}
        title="ConvoLink apps"
      >
        <img
          src="/app-logos/fluent_apps-20-regular-light.svg"
          alt=""
          className="h-5 w-5"
          aria-hidden="true"
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full z-50 mt-3 w-[min(336px,calc(100vw-2rem))] rounded-2xl border border-slate-200 bg-white p-3 shadow-2xl shadow-slate-950/20">
          <div className="grid grid-cols-3 gap-1">
            {appLinks.map((app) => (
              <a
                key={app.name}
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="flex min-h-[96px] flex-col items-center justify-center gap-2 rounded-xl p-2 text-center transition-colors hover:bg-slate-100 focus:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 p-2 shadow-sm">
                  <img src={app.logo} alt="" className="h-full w-full object-contain" />
                </span>
                <span className="line-clamp-2 text-xs font-medium text-slate-700">
                  {app.name}
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AppSwitcher;
